export const COMPANY_NAME = "ROCKY MOUNTAIN DIVERSITY EVENTS";
export const COMPANY_SHORT = "Rocky Mountain Diversity Events";
export const COMPANY_INITIALS = "RMD";
export const COMPANY_ADDRESS_FULL = "15121 E 101st Way, Commerce City, CO 80022";
export const COMPANY_LOCATION = "Commerce City, CO";
export const COMPANY_REGION = "Adams County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=15121%20E%20101st%20Way%2C%20Commerce%20City%2C%20CO%2080022";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Focus", "value": "Diversity & Community Events" },
  { "label": "Service Area", "value": "Denver Metro Area" },
  { "label": "Location", "value": "Commerce City, CO" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Rocky Mountain Diversity Events" },
  { "label": "Type", "value": "Colorado Nonprofit Corporation" },
  { "label": "City / State", "value": "Commerce City, CO" },
  { "label": "Address", "value": "15121 E 101st Way, Commerce City, CO 80022" },
];

export const CARE_PILLARS = [
  { "icon": "✦", "title": "Cultural Celebration", "body": "Gatherings that honor the many cultures, traditions, and stories that make our community whole." },
  { "icon": "◐", "title": "Community Connection", "body": "Welcoming spaces where neighbors from every background can meet, share, and belong." },
  { "icon": "✿", "title": "Education & Awareness", "body": "Programs that broaden understanding and foster respect across differences." },
  { "icon": "❍", "title": "Inclusion for All", "body": "Events designed so everyone feels seen, valued, and invited to take part." },
];
